import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MapWrapperComponent } from './components/map-wrapper/map-wrapper.component';
import { NewMapComponent } from './components/new-map/new-map.component';
import { SearchMapComponent } from './components/search-map/search-map.component';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
    imports: [
        CommonModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,

        NewMapComponent,
        SearchMapComponent,
        MapWrapperComponent
    ],
    exports: [
        NewMapComponent,
        MapWrapperComponent
    ]
})
export class MapModule { }
